export default __webpack_public_path__ + "static/media/AM.f489f061.svg";